import './header.css'
import logo from '../../img/logo.png'
import onlinelogo from '../../img/online.gif'
import datalogo from '../../img/date.gif'
import moment from "moment-jalaali";
import menu from '../../img/menu.png'
export default function Header(props){
    function showmenu() {
        props.showmenu ? props.setShowmenu(false) : props.setShowmenu(true)
    }
    moment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });
    return(
        <div className='headerbox'>
            <div className='menubox'><img className='menupage' src={menu} alt='menu' onClick={showmenu}></img><p>منو صفحات</p></div>
            <div className='onlineusers'><img src={onlinelogo} alt='online' loading='lazy'></img><p className='onlinefont'>{props.onlineUsers}</p><p>آنلاین</p></div>
            <img className='logohead' src={logo} alt='logo' loading='lazy'></img>
            <div className='date'><img src={datalogo} alt='date' loading='lazy'></img><p>{moment().format("jD jMMMM jYYYY")}</p></div>
        </div>
    )
}